import { ProductLayout } from "./product-list";

const ProductGridItemSkeleton = () => (
  <div>
    <div className="mb-3 rounded overflow-hidden animate-pulse">
      <div>
        <div className="relative rounded-t pb-full">
          <div className="absolute inset-0 w-full h-full bg-gray-200" />
        </div>
        <div className="my-2">
          <div className="w-4/5 h-3 bg-gray-200 rounded" />
          <div className="w-3/5 h-3 bg-gray-200 rounded mt-1" />
        </div>
      </div>
      <div className="h-4 bg-gray-200 rounded" />
    </div>
  </div>
);

const ProductListItemSkeleton = () => (
  <div>
    <div className="mb-3 rounded overflow-hidden animate-pulse">
      <div className="flex flex-row">
        <div className="shrink-0 mr-2">
          <div className="w-14 h-14 rounded-md bg-gray-200" />
        </div>
        <div className="flex-1 relative pb-2">
          <div className="w-4/5 h-3 bg-gray-200 rounded" />
          <div className="w-2/5 h-3 bg-gray-200 rounded mt-1" />
          <div className="flex flex-wrap justify-between">
            <div className="w-1/5 h-3 bg-gray-200 rounded mt-1" />
            <div className="flex flex-row">
              <div className="w-6 h-4 bg-gray-200 rounded-full mr-1" />
              <div className="w-6 h-4 bg-gray-200 rounded-full mr-1" />
              <div className="w-6 h-4 bg-gray-200 rounded-full" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

interface Props {
  mode: ProductLayout;
}

export const ProductListSkeleton = ({ mode }: Props) => {
  return mode === ProductLayout.grid ? (
    <div className="w-full flex overflow-x-auto py-4 no-scrollbar">
      <div className="flex flex-col mr-3 w-1/2">
        {Array.from(Array(5)).map((_, index) => (
          <ProductGridItemSkeleton key={index} />
        ))}
      </div>
      <div className="flex flex-col w-1/2">
        {Array.from(Array(5)).map((_, index) => (
          <ProductGridItemSkeleton key={index} />
        ))}
      </div>
    </div>
  ) : (
    <div className="w-full overflow-y-auto py-4 no-scrollbar">
      {Array.from(Array(10)).map((_, index) => (
        <ProductListItemSkeleton key={index} />
      ))}
    </div>
  );
};

export const LocationPickerSkeleton = () => (
  <div className="flex flex-col">
    <div className="rounded animate-pulse w-28 h-3 bg-gray-200 mb-1" />
    <div className="rounded animate-pulse w-40 h-3 bg-gray-200" />
  </div>
);
